import type { TRuleWithTheme } from '@ackee/fela';

export const postsContainer: TRuleWithTheme = () => ({
    paddingTop: 0,

    desktop: {
        paddingTop: 0,
    },
});

export const posts: TRuleWithTheme = () => ({
    desktop: {
        gridTemplateColumns: 'repeat(3, 1fr)',
    },
});

export const post: TRuleWithTheme = () => ({
    marginBottom: '3rem',
    desktop: { marginBottom: 0 },
});
